export enum FeatureFlagTipo {
  MANDATORY = 'MANDATORY',
  USER_CONFIGURABLE = 'USER_CONFIGURABLE',
  PERCENTAGE = 'PERCENTAGE',
  TEMPORAL = 'TEMPORAL',
  SEGMENTED = 'SEGMENTED',
  KILL_SWITCH = 'KILL_SWITCH'
}

export enum FeatureFlagEscopo {
  GLOBAL = 'GLOBAL',
  ENVIRONMENT = 'ENVIRONMENT',
  INTEGRADOR = 'INTEGRADOR',
  TENANT = 'TENANT',
  USER = 'USER'
}

export enum StatusFeatureFlag {
  INATIVA = 'INATIVA',
  TRANSICAO = 'TRANSICAO',
  OBRIGATORIA = 'OBRIGATORIA'
}

export enum FeatureFlagChave {
  PRE_CADASTRO_CODIGO_ENFORCEMENT = 'pre_cadastro_codigo_enforcement',
  META_BUSINESS_SENDING = 'meta-business-sending',
  TIMELINE_V2_PAGINATED = 'timeline_v2_paginated',
  CONVITE_VIRTUAL_MENU = 'conviteVirtualMenu',
  CHAVE_VIRTUAL_MENU = 'chaveVirtualMenu',
  ROTAS_UNIDADES = 'rotasUnidades',
  CONTROLE_ACESSO_FACIAL = 'controleAcessoFacial',
  OCULTAR_COLUNA_INTEGRADO = 'ocultarColunaIntegrado',
  OCULTAR_PORTAS_UNIDADE = 'ocultarPortasUnidade',
  OCULTAR_ABA_PSIM = 'ocultarAbaPSIM',
  LOGIN_WEB_V2 = 'login_web_v2'
}
